import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductGroup from '../../models/ProductGroup';


export interface ProductGroupDetailState extends ApiState {
  productGroup?: ProductGroup
}

export default requestReducer<ProductGroupDetailState>('PRODUCTGROUP_DETAIL')
